import React from "react";
import { Routes, Route } from "react-router-dom";
import Homepage from "../../views/Homepage";
import HomeLoan from "../../views/HomeLoan";
import Landscaping from "../../views/Landscaping";
import ConstructionConsultation from "../../views/ConstructionConsultation";
import CustomerSupport from "../../views/CustomerSupport";
import ArchiDesign from "../../views/ArchiDesign";
import HousingPlots from "../../views/HousingPlots";
import PremiumConstruction from "../../views/PremiumConstruction";
import JobPortal from "../../views/JobPortal";
import DocumentUploadReq from "../../pages/Builders/DocumentUploadReq";
import BuildersInfo from "../../views/BuildersInfo";
import BuildersList from "../../views/BuildersList";
import ProtectedLoginRoute from "../ProtectedLoginRoute";
import TermsCondition from "../../views/TermsCondition";
import PrivacyPolicy from "../../views/PrivacyPolicy";
import ForgotPasswordPage from "../../pages/Builders/ForgotPasswordPage";
import ResetPasswordPage from "../../pages/Builders/ResetPasswordPage";
import Signuppage from "../../pages/Signuppage"; // Builder Signup
import CustomerSignup from "../../pages/Customer/CustomerSignup"; // Customer Signup
import RefundPolicy from "../../views/RefundPolicy";
import CustomerForgotPasswordPage from "../../pages/Customer/ForgotPasswordPage"; // Import new page
import BlogListPage from "../../pages/BlogListPage";
import BlogPostPage from "../../pages/BlogPostPage";
import JoinUs from "../../views/JoinUs";
import HousingDetail from "../../layout/realestateagent/HousingPost/HousingDetail";
import PropertySearch from "../../views/PropertySearch";
import ConsultantDiscovery from "../../pages/Customer/ConsultantDiscovery";


const LandingRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Homepage />} />
      <Route path="/consultants" element={<ConsultantDiscovery />} />
      <Route path="/homeloan" element={<HomeLoan />} />
      <Route path="/landscaping" element={<Landscaping />} />
      <Route
        path="/constructionconsultation"
        element={<ConstructionConsultation />}
      />
      <Route path="/support" element={<CustomerSupport />} />
      <Route path="/archidesign" element={<ArchiDesign />} />
      <Route path="/housingplots" element={<HousingPlots />} />
      <Route path="/premiumconstruction" element={<PremiumConstruction />} />
      <Route path="/job-portal" element={<JobPortal />} />
      <Route path="/login" element={<ProtectedLoginRoute />} />

      <Route path="/upload-doc/:id" element={<DocumentUploadReq />} />
      <Route path="/buildersinfo/:builderId" element={<BuildersInfo />} />
      <Route path="/builderslist" element={<BuildersList />} />
      <Route path="/termscondition" element={<TermsCondition />} />
      <Route path="/refundpolicy" element={<RefundPolicy />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      <Route path="/builder/signup" element={<Signuppage />} />
      <Route path="/customer/signup" element={<CustomerSignup />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/blogs" element={<BlogListPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/joinus" element={<JoinUs />} />
      <Route path="/property/:id" element={<HousingDetail />} />
      <Route path="/properties" element={<PropertySearch />} />
    </Routes>
  );
};

export default LandingRoutes;
